module.exports={
	"Hash": "plansheet",
	"Name": "Plan Sheet",
	"Version": "1.0.0",
	"Description": "The Plansheet default pair: vellum in the light (warm tracing paper, graphite ink, Staedtler cobalt) and night drafting in the dark (neutral graphite ground, brightened cobalt). Amber is measurement ink: it marks dimensions, revisions, and warnings, nothing else.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary":   { "Light": "#F5F0E4", "Dark": "#14171C" },
				"Secondary": { "Light": "#EDE6D6", "Dark": "#1B1F26" },
				"Tertiary":  { "Light": "#E5DCC7", "Dark": "#232830" },
				"Panel":     { "Light": "#FBF8F0", "Dark": "#1B1F26" },
				"Hover":     { "Light": "#ECE4D2", "Dark": "#242A33" },
				"Selected":  { "Light": "#DCE5F2", "Dark": "#243650" }
			},
			"Text": {
				"Primary":     { "Light": "#2B2D2F", "Dark": "#E9ECF0" },
				"Secondary":   { "Light": "#46484A", "Dark": "#C2C8D1" },
				"Muted":       { "Light": "#6C6A60", "Dark": "#98A2AE" },
				"Placeholder": { "Light": "#9A947F", "Dark": "#5F6873" }
			},
			"Brand": {
				"Primary":      { "Light": "#1D5FA8", "Dark": "#4F95E8" },
				"PrimaryHover": { "Light": "#174E8C", "Dark": "#6BA7EE" },
				"Accent":       { "Light": "#A8780E", "Dark": "#F2C84B" }
			},
			"Border": {
				"Default": { "Light": "#CFC6B0", "Dark": "#2E3640" },
				"Light":   { "Light": "#DFD7C4", "Dark": "#262C35" },
				"Strong":  { "Light": "#A89F87", "Dark": "#46505C" }
			},
			"Status": {
				"Success": { "Light": "#2F7A3C", "Dark": "#5FC377" },
				"Warning": { "Light": "#A8780E", "Dark": "#F2C84B" },
				"Error":   { "Light": "#A33B2E", "Dark": "#E8786A" },
				"Info":    { "Light": "#1D5FA8", "Dark": "#5F9FE8" }
			},
			"Scrollbar": {
				"Track": { "Light": "#E7DFCC", "Dark": "#1A1D23" },
				"Thumb": { "Light": "#C9BFA6", "Dark": "#333B46" },
				"Hover": { "Light": "#A89F87", "Dark": "#4A5560" }
			},
			"Selection": {
				"Background": { "Light": "#C9DBF2", "Dark": "#2C4A75" },
				"Text":       { "Light": "#2B2D2F", "Dark": "#E9ECF0" }
			},
			"Focus": {
				"Outline": { "Light": "#1D5FA8", "Dark": "#4F95E8" }
			},
			"Shadow": {
				"Color": { "Light": "rgba(43, 45, 47, 0.14)", "Dark": "rgba(0, 0, 0, 0.5)" }
			},
			"Syntax": {
				"Keyword":     { "Light": "#8A4FA0", "Dark": "#C678DD" },
				"String":      { "Light": "#3E7E3E", "Dark": "#98C379" },
				"Number":      { "Light": "#A8780E", "Dark": "#E5C07B" },
				"Comment":     { "Light": "#9A947F", "Dark": "#6E7681" },
				"Operator":    { "Light": "#1D5FA8", "Dark": "#56B6C2" },
				"Punctuation": { "Light": "#46484A", "Dark": "#ABB2BF" },
				"Function":    { "Light": "#1D5FA8", "Dark": "#6BA7EE" },
				"Variable":    { "Light": "#2B2D2F", "Dark": "#E06C75" },
				"Type":        { "Light": "#A8780E", "Dark": "#E5C07B" },
				"Builtin":     { "Light": "#8A5A00", "Dark": "#D19A66" },
				"Property":    { "Light": "#A33B2E", "Dark": "#E06C75" },
				"Tag":         { "Light": "#A33B2E", "Dark": "#E06C75" },
				"AttrName":    { "Light": "#8A5A00", "Dark": "#D19A66" },
				"AttrValue":   { "Light": "#3E7E3E", "Dark": "#98C379" }
			}
		},
		"Typography": {
			"Family": {
				"Sans": "system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
				"Serif": "Georgia, Cambria, Times New Roman, Times, serif",
				"Mono": "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
				"Display": "'Gorton Perfected', ui-monospace, SFMono-Regular, Menlo, Consolas, monospace"
			},
			"Display": {
				"Transform": "uppercase",
				"Tracking": "1.5px",
				"Weight": "700"
			},
			"Size": {
				"XS": "0.75rem",
				"SM": "0.875rem",
				"MD": "1rem",
				"LG": "1.125rem",
				"XL": "1.375rem",
				"XXL": "1.75rem"
			},
			"Weight": {
				"Regular": "400",
				"Medium": "500",
				"Bold": "700"
			},
			"LineHeight": {
				"Tight": "1.2",
				"Normal": "1.45",
				"Loose": "1.7"
			}
		},
		"Spacing": {
			"XS": "4px",
			"SM": "8px",
			"MD": "12px",
			"LG": "16px",
			"XL": "24px",
			"XXL": "32px"
		},
		"Radius": {
			"None": "0",
			"SM": "2px",
			"MD": "4px",
			"LG": "8px",
			"XL": "12px",
			"Pill": "999px"
		},
		"Shadow": {
			"SM": "0 1px 2px var(--theme-color-shadow-color)",
			"MD": "0 2px 6px var(--theme-color-shadow-color)",
			"LG": "0 6px 18px var(--theme-color-shadow-color)"
		},
		"ZIndex": {
			"Base": "0",
			"Dropdown": "100",
			"Sticky": "200",
			"Overlay": "900",
			"Modal": "1000",
			"Toast": "2000",
			"Tooltip": "3000"
		},
		"Duration": {
			"Fast": "100ms",
			"Normal": "200ms",
			"Slow": "400ms"
		}
	},
	"Brand": {
		"Name": "Plansheet",
		"Tagline": "Everything, drafted."
	}
}
